import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { Loading } from "../SVG";
import WebServiceContext from "../../webService/WebServiceContext";


type LotteryProps = {
    currentYear: number
}

const Lottery = (props:LotteryProps) => {
    const ws = useContext(WebServiceContext)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [collapseList, setCollapseList] = useState<boolean[]>([])

    const [gold, setGold] = useState<number>(0)
    const [silver, setSilver] = useState<number>(0)
    const [copper, setCopper] = useState<number>(0)
    const [year, setYear] = useState<number>(props.currentYear)

    useEffect(() => {
        setIsLoading(true)
        ws.webservice.asyncPerformance("44006_年終摸彩劵", props.currentYear).then((res: any) => {
            setIsLoading(false)
            if(res.length>0){
                setGold(res[0]['金張數']?res[0]['金張數']:0)
                setSilver(res[0]['銀張數']?res[0]['銀張數']:0)
                setCopper(res[0]['銅張數']?res[0]['銅張數']:0)
            }
        })
        return
    }, [props.currentYear])

    if (isLoading) {
        return <Loading />
    } else {
        return (
            <>
                <div className="card-short">
                    
                    <span className="gold">
                        金：<span className="value">{gold}</span>
                    </span>
                    <div className="silver">
                        銀：<span className="value">{silver}</span>
                    </div>
                    <div className="copper">
                        銅：<span className="value">{copper}</span>
                    </div>
                </div>
                <div className="card-content">
                    <div className="lottery">
                        <div className="row">
                            <div>
                                <img src="./images/HIB_lottery_gold.png" />
                            </div>
                            <div className="total gold">
                                {gold}
                            </div>
                        </div>
                        <div className="row">
                            <div>
                                <img src="./images/HIB_lottery_silver.png" />
                            </div>
                            <div className="total silver">
                                {silver}
                            </div>
                        </div>
                        <div className="row">
                            <div>
                                <img src="./images/HIB_lottery_copper.png" />
                            </div>
                            <div className="total copper">
                                {copper}
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}
export default Lottery